<template>
	<transition name="modal-fade">
		<div class="modal-backdrop" @click.self="$emit('close')">
			<div class="modal-window" @click.stop>
				<h3>{{ $t('legacy.Детали стоимости') }}</h3>

				<ul v-if="items.length" class="items-list">
					<li v-for="item in items" :key="item.id" class="item">
						<img class="item-image" :src="item.src" :alt="$t('legacy.Изображение товара')" />
						<span class="item-price">{{ $formatNumber(item.price) }} {{ $t('common.rubles') }}</span>
					</li>
				</ul>

				<p v-else class="empty-message">{{ $t('legacy.Элементы отсутствуют') }}</p>

				<button class="close-btn" @click="$emit('close')">{{ $t('common.close') }}</button>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	props: {
		items: {
			type: Array,
			required: true
		}
	}
}
</script>

<style scoped>
/* Анимация появления/исчезания модалки */
.modal-fade-enter-active,
.modal-fade-leave-active {
	transition: opacity 0.3s ease, transform 0.3s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
	opacity: 0;
	transform: scale(0.9);
}

.modal-fade-enter-to,
.modal-fade-leave-from {
	opacity: 1;
	transform: scale(1);
}

/* Подложка */
.modal-backdrop {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.6);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 10000;
	backdrop-filter: blur(4px);
}

/* Окно модалки */
.modal-window {
	background: #fff;
	padding: 32px 36px;
	border-radius: 16px;
	width: 380px;
	max-height: 80vh;
	overflow-y: auto;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
	display: flex;
	flex-direction: column;
}

/* Заголовок */
h3 {
	margin: 0 0 20px;
	font-size: 22px;
	font-weight: 700;
	color: #1a2a47;
	text-align: center;
	letter-spacing: 0.03em;
}

/* Список товаров */
.items-list {
	list-style: none;
	padding: 0;
	margin: 0 0 28px;
	max-height: 55vh;
	overflow-y: auto;
	scrollbar-width: thin;
	scrollbar-color: #a0aec0 transparent;
}

.items-list::-webkit-scrollbar {
	width: 6px;
}

.items-list::-webkit-scrollbar-thumb {
	background-color: #a0aec0;
	border-radius: 3px;
}

/* Элемент товара */
.item {
	display: flex;
	align-items: center;
	gap: 16px;
	margin-bottom: 14px;
	border-bottom: 1px solid #e6e9f0;
	padding-bottom: 10px;
}

/* Изображение товара */
.item-image {
	width: 56px;
	height: 56px;
	object-fit: cover;
	border-radius: 10px;
	box-shadow: 0 2px 6px rgba(26, 42, 71, 0.1);
	flex-shrink: 0;
	transition: transform 0.3s ease;
}

.item-image:hover {
	transform: scale(1.05);
}

/* Цена */
.item-price {
	font-weight: 700;
	font-size: 17px;
	color: #3b516a;
	margin-left: auto;
	white-space: nowrap;
}

/* Сообщение об отсутствии элементов */
.empty-message {
	text-align: center;
	color: #7a8ba6;
	font-size: 16px;
	margin: 40px 0 28px;
	font-style: italic;
}

/* Кнопка закрытия */
.close-btn {
	padding: 12px 0;
	background: linear-gradient(90deg, #3a86ff 0%, #0077ff 100%);
	border: none;
	border-radius: 12px;
	color: white;
	font-weight: 700;
	font-size: 18px;
	cursor: pointer;
	user-select: none;
	transition: background 1s ease;
}

.close-btn:hover {
	background: linear-gradient(90deg, #005fcc 0%, #004db3 100%);
	box-shadow: 0 6px 15px rgba(0, 119, 255, 0.45);
}
</style>
